<template>
    <ListModule
        :label="$t('components.smart.featuredCompanies.label')"
        :data="featuredCompanies"
        to="companydetail"
        :isLoading="loading"
    />
</template>

<script>
import CompanyService from '~/services/CompanyService';

export default {
    name: 'FeaturedCompanies',
    data() {
        return {
            singlePromotion: {
                8355: true, // Microsoft,
                203: true, // Schneider Electric HQ,
                8488: true, // Decathlon France
                3145: true, // BAT
            },
            featuredCompanies: [],
            loading: false,
        };
    },
    methods: {
        fetchFeaturedCompanies() {
            this.loading = true;
            CompanyService.getCompanies({
                page: 1,
                limit: 10,
                minified: false,
                subdomain: 'gethighered',
                companyIds: Object.keys(this.singlePromotion),
            })
                .then(response => {
                    this.featuredCompanies = response.data
                        .sort(() => 0.5 - Math.random())
                        .slice(0, 5)
                        .map(value => ({
                            id: value.id,
                            header: value.title,
                            subheader: ''.concat(
                                value.country || '',
                                value.country && value.location ? ', ' : '',
                                value.location || ''
                            ),
                            image: value.logo,
                        }));
                })
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.fetchFeaturedCompanies();
    },
};
</script>

<style scoped></style>
